import React, { useState, Fragment, useMemo } from 'react'

import SystemPopup from '../../components/systemPopup'
import PopupProvider from '../../context/popupContext'
import { registerLoadingBarFunction } from '../../util/globalFunction'

import loadingCircle from '../../static/images/loadingCircle.gif'

export default props => {
    const [count, setLoadingCount] = useState(0)
    const [loadingBarHeight, setLoadingBarHeight] = useState(0)
    const [loadingBarMarginTop, setLoadingBarMarginTop] = useState(0)

    registerLoadingBarFunction(
        () => setLoadingCount(count + 1),
        () => count > 0 && setLoadingCount(count - 1),
        () => setLoadingCount(0)
    )

    const handleClick = () => {
        setLoadingCount(0)
    }

    useMemo(() => {
        if(count > 0) {
            const scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
            setLoadingBarHeight(scrollHeight)
            const clientHeight = document.documentElement.clientHeight;
            setLoadingBarMarginTop((clientHeight/2)-100)
        }
    }, [count])

    return (
        <Fragment>
            <PopupProvider>
                <SystemPopup />
            </PopupProvider>
            {count > 0 ? (
                <div
                    className="absolute left-0 w-full overflow-hidden z-40 flex justify-center bg-opacity-20 bg-gray-800"
                    style={{height: loadingBarHeight}}
                    // onClick={handleClick}
                >
                    <img 
                        src={loadingCircle} 
                        alt="loading bar" 
                        style={{marginTop: loadingBarMarginTop, position: 'absolute'}}
                    />
                </div>
            ) : null}
        </Fragment>
    )
}
